import { BaseModel } from '../../core/abstractions/base.model';

/**
 * Represents an URL parameter
 */
export class UrlParameterModel extends BaseModel {
    /**
     * Key.
     */
    key: string;

    /**
     * Value.
     */
    value: string;

    constructor(init: UrlParameterModel) {
        super();
        Object.assign(this, init);
    }
}
